// SPDX-FileCopyrightText: © 2024 Schneider Electric
//
// SPDX-License-Identifier: Apache-2.0

import checked from '@quartzds/generic-icons-core/checked.svg'
import clear from '@quartzds/generic-icons-core/clear.svg'
import draggable from '@quartzds/generic-icons-core/draggable.svg'
import dropdown from '@quartzds/generic-icons-core/dropdown.svg'
import externalLink from '@quartzds/generic-icons-core/external-link.svg'
import indeterminate from '@quartzds/generic-icons-core/indeterminate.svg'
import inputDate from '@quartzds/generic-icons-core/input-date.svg'
import inputDatetimeLocal from '@quartzds/generic-icons-core/input-datetime-local.svg'
import inputEmail from '@quartzds/generic-icons-core/input-email.svg'
import inputMonth from '@quartzds/generic-icons-core/input-month.svg'
import inputPasswordHide from '@quartzds/generic-icons-core/input-password-hide.svg'
import inputPasswordShow from '@quartzds/generic-icons-core/input-password-show.svg'
import inputSearch from '@quartzds/generic-icons-core/input-search.svg'
import inputTel from '@quartzds/generic-icons-core/input-tel.svg'
import inputTime from '@quartzds/generic-icons-core/input-time.svg'
import inputUrl from '@quartzds/generic-icons-core/input-url.svg'
import inputWeek from '@quartzds/generic-icons-core/input-week.svg'
import navigation from '@quartzds/generic-icons-core/navigation.svg'
import next from '@quartzds/generic-icons-core/next.svg'
import statusError from '@quartzds/generic-icons-core/status-error.svg'
import statusInfo from '@quartzds/generic-icons-core/status-info.svg'
import statusWarning from '@quartzds/generic-icons-core/status-warning.svg'

import type { IconLibrary } from './library'

const icons: Record<string, string | undefined> = {
  /* eslint-disable @typescript-eslint/naming-convention */
  clear,
  checked,
  draggable,
  dropdown,
  'external-link': externalLink,
  'external-new-tab-link': externalLink,
  indeterminate,
  'input-month': inputMonth,
  'input-tel': inputTel,
  'input-week': inputWeek,
  'input-url': inputUrl,
  'input-time': inputTime,
  'input-date': inputDate,
  'input-datetime-local': inputDatetimeLocal,
  'input-email': inputEmail,
  'input-search': inputSearch,
  'input-password-hide': inputPasswordHide,
  'input-password-show': inputPasswordShow,
  navigation,
  next,
  close: statusError,
  'status-error': statusError,
  'status-info': statusInfo,
  'status-success': checked,
  'status-warning': statusWarning,
  /* eslint-enable @typescript-eslint/naming-convention */
}

const coreLibrary: IconLibrary = {
  name: 'core',
  resolver: (name) => icons[name] ?? '',
}

export default coreLibrary
